define(function(require) {
	'use strict';
	var $ = require('jquery'),
		_ = require('underscore'),
		Backbone = require('backbone'),
		html_template = require('common/templates/notifications/FeatureNotification.html'),
		template = _.template(html_template);

	return Backbone.View.extend({
		events: {
            'click .bn-holder .close': 'onCloseNotification',
            'click .bnh-buttons-confirm a': 'onCloseNotificationAndRedirect'
            
        },
		initialize : function() {
			this.notification = this.options.notification;
		},
		render : function() {
			var data = this._prepareData();
			this.$el.html(template(data));
			return this;
		},
		show : function() {
			$('div.banner-notification').fadeIn('slow');
		},
		
		onCloseNotification: function(event) {
        	event.preventDefault();
            Backbone.trigger("notifications:onConfirm", this.notification);
        },
        
        onCloseNotificationAndRedirect: function(event) {
        	event.preventDefault();
        	Backbone.on("notifications:onConfirmed", _.bind(this.redirect, this));
            Backbone.trigger("notifications:onConfirm", this.notification);
        },
        
        redirect : function() {
        	window.location.href = this.notification.url;
        },
        
		_prepareData : function() {
			var data = {
				title : this.notification.title,
				notification : this.notification.notification,
				type : this.notification.type,
				url : this.notification.url,
				urlTitle : this.notification.urlTitle,
				i18n : i18n
			};
			return data;
		}
	});
});



//////////////////
// WEBPACK FOOTER
// ./js/common/views/notifications/FeatureNotification.js
// module id = 1070
// module chunks = 26 27 28